/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

// node_modules
import React, { Component } from "react";

// local components
import Notification from "./Notification.js";

// utils
import NotificationUtils from "utils/notification-utils/NotificationUtils.js";

// constants
const ANIMATION_FADE_TIME = 3;
const ANIMATION_SECOND_MULTIPLIER = 1000;
const ZINDEX = 2147483647; // absolute top

class Notifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notifications: null
    };
  }

  render() {
    return (
      <div
        className={"container-fluid"}
        style={{
          height: "100vh",
          left: 0,
          pointerEvents: "none",
          position: "fixed",
          top: 0,
          width: "100vw",
          zIndex: ZINDEX
        }}
      >
        <div className={"row"}>
          {this.handleRenderNotifications()}
        </div>
      </div>
    );
  }

  componentDidMount() {
    NotificationUtils.subscribe((notification) => {
      const { duration, id } = notification;
      const notificationsAddNew = {
        ...this.state.notifications,
        [id]: { ...notification }
      };
      this.setState({ notifications: notificationsAddNew });
      setTimeout(() => {
        const notificationsRemoveOld = { ...this.state.notifications };
        delete(notificationsRemoveOld[id]);
        this.setState({ notifications: notificationsRemoveOld });
      }, ((ANIMATION_FADE_TIME + duration) * ANIMATION_SECOND_MULTIPLIER));
    });
  }

  handleRenderNotifications = () => {
    const { state } = this;
    const { notifications } = state;
    const notificationsRender = [];
    for(const key in notifications) {
      if(notifications[key]) {
        const notification = notifications[key];
        const { duration, message, type } = notification;
        notificationsRender.push(
          <Notification
            duration={duration * ANIMATION_SECOND_MULTIPLIER}
            key={key}
            message={message}
            type={type}
          />
        );
      }
    }
    return notificationsRender;
  };
}
export default Notifications;
